import {DialogOverlayDefaultBox} from './dialog-overlay.default.box';
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {DialogOverlayMrGreenBox} from "./dialog-overlay.mrgreen.box";

export const DialogOverlayBox = styledByTheme(DialogOverlayDefaultBox)
    .forMrGreen(DialogOverlayMrGreenBox)
    .apply();